/* eslint-disable @typescript-eslint/semi */
import { DeviceType } from './device-type';
import { Car, cLast } from './car.entity';
import { Base } from './base';
import { DataService } from '../data.service';
import { Wifi } from './wifi';
import { Observable, Subscription } from 'rxjs';
import { WifiInfo } from './WifiInfo';

/* eslint-disable @typescript-eslint/semi */
export class Device {

  _page = "Device"
  __iAm: string = "Device"

  id: string = ''
  //deviceId: string = ''

  macaddress = ''
  label = ''

  public wifi: WifiInfo = WifiInfo.factory()
  wifipassword = ''

  wifiState = ''
  bluetoothState = ''

  public wifiStateBackend = ''

  type: any = 'radio'
  value: any = ''
  selected = false

  installedIn: string = ''

  car: Car = null; //new Car()

  registeredTo = ''

  lastSeenAt = ''
  createdAt = ''
  updatedAt = ''

  deviceType: string = DeviceType.Dev50

  last: {
    voltage: {
      status: string
      value: number
    },
    current: {
      status: string
      value: number
    },
    temperature: {
      status: string
      value: number
    },
    humidity: {
      status: string
      value: number
    },
    pressure: {
      status: string
      value: number
    },
    timestamp: {
      status: string
      value: number
    },
    wifiSsid: {
      status: string
      value: string
    }
  }


  // eslint-disable-next-line max-len
  constructor(id: string, macaddress: string, label: string, wifi: WifiInfo, bluetoothState: string, wifiState: string) {

    if (id === null || id === undefined || id === '') {
      Base.log("[" + this._page + "] Null device")
    } else {
      this.id = id

      this.macaddress = macaddress
      this.label = label
      this.wifi = wifi
      this.value = label
      this.selected = false
      this.deviceType = this.id.substring(0, 3)
      Base.log("[" + this._page + "] DeviceType of " + this.id + " is " + this.deviceType)

      this.bluetoothState = bluetoothState
      this.wifiState = wifiState
    }
  }


  static factory(d) {
    Base.log("[device] factory")
    Base.log(d)

    const temp = new Device(d.id, d.macaddress, d.label, d.wifi, d.bluetoothState, d.wifiState)
    temp.id = d.id
    temp.installedIn = d.installedIn
    temp.registeredTo = d.registeredTo
    temp.lastSeenAt = d.lastSeenAt
    temp.createdAt = d.createdAt
    temp.updatedAt = d.updatedAt
    temp.wifi = d.wifi
    if (d.last===null || d.last === undefined) {
      temp.last = d.last
    } else {
      temp.last = {
        voltage: {
          status: "",
          value: 0
        },
        current: {
          status: "",
          value: 0
        },
        temperature: {
          status: "",
          value: 0
        },
        humidity: {
          status: "",
          value: 0
        },
        pressure: {
          status: "",
          value: 0
        },
        timestamp: {
          status: "",
          value: 0
        },
        wifiSsid: {
          status: "",
          value: ""
        }
      }
    }
    temp.wifiStateBackend = ""
    
    Base.log("[device] factory result")
    Base.log(temp)

    return temp

  }

  getWifi(dataService: DataService) {
    Base.log("[Device]getWifi for " + this.id)

    dataService.getWifiData(this.id).then((wifiInfo)=>{
    Base.log("[Device]getWifi_readata for " + this.id)
    Base.log(wifiInfo)
    
   
    })

    return dataService.getDevicesFromBackend().forEach((devices: any) => {

      devices.forEach((temp) => {
        Base.log("........")
        Base.log(temp)

        const dev = Device.factory(temp)

        Base.log("[Device]grabbing " + dev.id)
        Base.log(dev)

        if (dev.id === this.id) {
          Base.log("--== DEV found ==--")
          Base.log(dev.last)

          this.wifiStateBackend = dev.last.wifiSsid.value
          Base.log("wifiStateBackend: " + this.wifiStateBackend)

          //dataService.setWifi(this.id, dev.last.wifiSsid.value)
          //dataService.setWifiCnt(this.id, dev.last.wifiSsid.value, 0)

          return this.wifiStateBackend
          
        }
      })
    })
    //return
  }
  

  get name() {
    return this.label
  }

  set name(name) {
    this.label = name
  }

  // generate toString() methode
  toString(): string {
    return JSON.stringify(this)
  }
}
